import type { ReactNode } from 'react';
import { Stack, Typography } from '@mui/material';

interface DrawerSectionProps {
  sections: {
    id: string;
    title: ReactNode;
    content: ReactNode;
  }[];
}

const sectionHeaderSx = {
  pb: 0.5,
  borderBottom: 1,
  borderColor: 'primary.light',
};

export const DrawerSection = ({ sections }: DrawerSectionProps) => (
  <Stack gap={4}>
    {sections.map(section => (
      <Stack key={section.id} gap={1.5}>
        <Typography variant="subtitle1" color="brand" sx={sectionHeaderSx}>
          {section.title}
        </Typography>
        {section.content}
      </Stack>
    ))}
  </Stack>
);
